export async function hashString(input) {
    const encoder = new TextEncoder(); // Create a new TextEncoder instance
    const data = encoder.encode(input); // Convert the input string to a Uint8Array
    const hashBuffer = await crypto.subtle.digest('SHA-256', data); // Hash the data
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert buffer to byte array
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // Convert byte array to hex string
    return hashHex; // Return the hash in hex format
}
